export default __webpack_public_path__ + "static/background-2023-2fe31d57282d364fba94364608a7275c.jpg";